interface IProps {
    color?: string;
}

export const IconBasket = (propse: IProps) => {
    return (
        <svg
            width="39"
            height="36"
            viewBox="0 0 39 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.62741 14.5108L9.43141 24.0735C9.49008 24.8095 10.0914 25.3615 10.8261 25.3615H10.8314H25.3794H25.3821C26.0767 25.3615 26.6701 24.8442 26.7687 24.1575L28.0354 15.4122C28.0647 15.2042 28.0127 14.9962 27.8861 14.8282C27.7607 14.6588 27.5767 14.5495 27.3687 14.5202C27.0901 14.5308 15.5261 14.5148 8.62741 14.5108ZM10.8234 27.3615C9.06741 27.3615 7.58074 25.9908 7.43808 24.2375L6.21674 9.71218L4.20741 9.36551C3.66208 9.26951 3.29808 8.75351 3.39141 8.20818C3.48741 7.66284 4.01408 7.30818 4.54741 7.39351L7.32074 7.87351C7.76741 7.95218 8.10741 8.32284 8.14608 8.77618L8.45941 12.5108C27.4941 12.5188 27.5554 12.5282 27.6474 12.5388C28.3901 12.6468 29.0434 13.0348 29.4887 13.6322C29.9341 14.2282 30.1207 14.9628 30.0141 15.6988L28.7487 24.4428C28.5101 26.1068 27.0647 27.3615 25.3847 27.3615H25.3781H10.8341H10.8234Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.2406 19.4393H19.5446C18.9913 19.4393 18.5446 18.9913 18.5446 18.4393C18.5446 17.8873 18.9913 17.4393 19.5446 17.4393H23.2406C23.7926 17.4393 24.2406 17.8873 24.2406 18.4393C24.2406 18.9913 23.7926 19.4393 23.2406 19.4393Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2498 30.9835C10.6511 30.9835 10.9751 31.3075 10.9751 31.7089C10.9751 32.1102 10.6511 32.4355 10.2498 32.4355C9.84715 32.4355 9.52315 32.1102 9.52315 31.7089C9.52315 31.3075 9.84715 30.9835 10.2498 30.9835Z"
                fill="white"
            />
            <mask id="mask0_1884_1129" maskUnits="userSpaceOnUse" x="9" y="30" width="2" height="3">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.52248 31.7083C9.52248 32.111 9.84648 32.4363 10.2505 32.4363C10.6518 32.4363 10.9758 32.111 10.9758 31.7083C10.9758 31.307 10.6518 30.983 10.2505 30.983C9.84648 30.983 9.52248 31.307 9.52248 31.7083Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_1884_1129)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M2.85715 39.1016H17.6425V24.3163H2.85715V39.1016Z"
                    fill="white"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.2485 31.4354C10.0978 31.4354 9.97515 31.5581 9.97515 31.7087C9.97515 32.0114 10.5231 32.0114 10.5231 31.7087C10.5231 31.5581 10.3991 31.4354 10.2485 31.4354ZM10.2485 33.4354C9.29648 33.4354 8.52315 32.6607 8.52315 31.7087C8.52315 30.7567 9.29648 29.9834 10.2485 29.9834C11.2005 29.9834 11.9751 30.7567 11.9751 31.7087C11.9751 32.6607 11.2005 33.4354 10.2485 33.4354Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.2902 30.9835C25.6915 30.9835 26.0169 31.3075 26.0169 31.7089C26.0169 32.1102 25.6915 32.4355 25.2902 32.4355C24.8875 32.4355 24.5635 32.1102 24.5635 31.7089C24.5635 31.3075 24.8875 30.9835 25.2902 30.9835Z"
                fill="white"
            />
            <mask
                id="mask1_1884_1129"
                maskUnits="userSpaceOnUse"
                x="24"
                y="30"
                width="3"
                height="3"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M24.5638 31.7083C24.5638 32.111 24.8878 32.4363 25.2905 32.4363C25.6905 32.4363 26.0171 32.111 26.0171 31.7083C26.0171 31.307 25.6905 30.983 25.2905 30.983C24.8878 30.983 24.5638 31.307 24.5638 31.7083Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask1_1884_1129)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.8971 39.1016H32.6838V24.3163H17.8971V39.1016Z"
                    fill="white"
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25.2889 31.4354C25.1395 31.4354 25.0169 31.5581 25.0169 31.7087C25.0182 32.0141 25.5649 32.0114 25.5635 31.7087C25.5635 31.5581 25.4395 31.4354 25.2889 31.4354ZM25.2889 33.4354C24.3369 33.4354 23.5635 32.6607 23.5635 31.7087C23.5635 30.7567 24.3369 29.9834 25.2889 29.9834C26.2422 29.9834 27.0169 30.7567 27.0169 31.7087C27.0169 32.6607 26.2422 33.4354 25.2889 33.4354Z"
                fill="white"
            />
            <circle cx="29.9048" cy="9.57145" r="8.66667" fill="white" />
            {/* <path
                d="M29.7667 13.0048C29.4067 13.0048 29.0334 12.9581 28.6467 12.8648C28.2601 12.7715 27.9234 12.6315 27.6367 12.4448C27.5034 12.3581 27.4134 12.2581 27.3667 12.1448C27.3201 12.0315 27.3067 11.9248 27.3267 11.8248C27.3534 11.7181 27.4034 11.6281 27.4767 11.5548C27.5567 11.4815 27.6534 11.4381 27.7667 11.4248C27.8867 11.4115 28.0167 11.4415 28.1567 11.5148C28.4301 11.6615 28.6934 11.7681 28.9467 11.8348C29.2001 11.8948 29.4601 11.9248 29.7267 11.9248C30.0201 11.9248 30.2667 11.8848 30.4667 11.8048C30.6667 11.7248 30.8167 11.6048 30.9167 11.4448C31.0234 11.2848 31.0767 11.0915 31.0767 10.8648C31.0767 10.5315 30.9634 10.2848 30.7367 10.1248C30.5167 9.95812 30.1934 9.87479 29.7667 9.87479H29.1267C28.9401 9.87479 28.7967 9.82812 28.6967 9.73479C28.6034 9.64145 28.5567 9.51145 28.5567 9.34479C28.5567 9.17812 28.6034 9.04812 28.6967 8.95479C28.7967 8.86145 28.9401 8.81479 29.1267 8.81479H29.6467C29.9001 8.81479 30.1167 8.77478 30.2967 8.69478C30.4767 8.60812 30.6167 8.48812 30.7167 8.33478C30.8167 8.18145 30.8667 7.99478 30.8667 7.77479C30.8667 7.46812 30.7634 7.23479 30.5567 7.07479C30.3567 6.91478 30.0634 6.83478 29.6767 6.83478C29.4301 6.83478 29.1967 6.86478 28.9767 6.92478C28.7634 6.97812 28.5267 7.08145 28.2667 7.23478C28.1467 7.30812 28.0301 7.33812 27.9167 7.32478C27.8101 7.31145 27.7201 7.26812 27.6467 7.19478C27.5734 7.12145 27.5234 7.03479 27.4967 6.93479C27.4701 6.82812 27.4767 6.72145 27.5167 6.61479C27.5567 6.50145 27.6401 6.40478 27.7667 6.32478C28.0534 6.13812 28.3701 5.99812 28.7167 5.90478C29.0634 5.80478 29.4201 5.75478 29.7867 5.75478C30.2734 5.75478 30.6901 5.83145 31.0367 5.98478C31.3834 6.13145 31.6467 6.34478 31.8267 6.62478C32.0134 6.89812 32.1067 7.23145 32.1067 7.62479C32.1067 7.90478 32.0534 8.16145 31.9467 8.39478C31.8401 8.62145 31.6901 8.81478 31.4967 8.97479C31.3034 9.13479 31.0701 9.24812 30.7967 9.31478V9.19478C31.2767 9.27478 31.6501 9.47478 31.9167 9.79478C32.1834 10.1081 32.3167 10.5015 32.3167 10.9748C32.3167 11.3881 32.2134 11.7481 32.0067 12.0548C31.8001 12.3615 31.5067 12.5981 31.1267 12.7648C30.7467 12.9248 30.2934 13.0048 29.7667 13.0048Z"
                fill="#F22F46"
            /> */}
        </svg>
    );
};
